import { FORM_INPUT_CHANGE } from '../Utils/Constants';

const initialState = {
    username: '',
    password: '',
}

export const userFormReducer = (state = initialState, action) => {
    switch(action.type) {
        case FORM_INPUT_CHANGE:
            return {
                ...state,
                [action.payload.name]: action.payload.value
            }

        default:
            return state;
    }
}
